/**
 * Frontend mirror of services/ops-ui/src/auth/capabilities.ts.
 * Keep these two files in sync — the backend is the source of truth.
 *
 * Registers ops-ui's role -> capability mapping with the shared registry in
 * @nova-integration/auth. ops-ui is the only app that issues `diaper.nova.proxy`
 * (granted to ops/admin so they can hit Nova via the diaper-ui BFF).
 */

import { registerCapabilities } from '@nova-integration/ui-shared';

export const APP_ID = 'ops-ui';

export type UserRole = 'admin' | 'ops' | 'partner';

export type Capability =
  | 'partner.config.read.own'
  | 'partner.config.edit.filters.own'
  | 'partner.testevents.send.own'
  | 'partner.stats.read.own'
  | 'partner.eventlog.read.own'
  | 'ops.tenants.assign'
  | 'ops.partners.read.all'
  | 'ops.events.read.all'
  | 'ops.stats.read.all'
  | 'ops.queue.read'
  | 'admin.partners.crud'
  | 'admin.accounts.crud'
  | 'admin.sources.crud'
  | 'admin.queue.manage'
  | 'admin.users.crud'
  | 'admin.audit.read'
  | 'admin.tenants.crud'
  | 'diaper.nova.proxy';

const PARTNER: Capability[] = [
  'partner.config.read.own',
  'partner.config.edit.filters.own',
  'partner.testevents.send.own',
  'partner.stats.read.own',
  'partner.eventlog.read.own',
];

const OPS: Capability[] = [
  ...PARTNER,
  'ops.tenants.assign',
  'ops.partners.read.all',
  'ops.events.read.all',
  'ops.stats.read.all',
  'ops.queue.read',
  'diaper.nova.proxy',
];

const ADMIN: Capability[] = [
  ...OPS,
  'admin.partners.crud',
  'admin.accounts.crud',
  'admin.sources.crud',
  'admin.queue.manage',
  'admin.users.crud',
  'admin.audit.read',
  'admin.tenants.crud',
];

registerCapabilities(APP_ID, {
  partner: PARTNER,
  ops: OPS,
  admin: ADMIN,
});
